/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { sortBy } from 'lodash';
import Calendar from '../Calendar/calendar';
import { openModal } from '../../actions/modalActions';
import {
  getAllDeployments,
  addResultToDeployment,
  removeResultFromDeployment
} from '../../actions/deploymentActions';
import modalTypes from '../../constants/modalTypes';
import DeploymentRow from './deploymentRow';
import GrayPlus from '../Buttons/grayPlus';

const initialState = {
  tfil: '',
  pfil: '',
  gfil: '',
  sc: false,
  // open: 'YWxs',
  mod: '',
  tf: ''
};

class DeploymentsWall extends React.Component {
  constructor() {
    super();
    this.state = {
      showCompleted: false,
      preservedState: initialState
    };
  }

  componentWillMount() {
    this.props.getAllDeployments();
  }

  componentDidMount() {
    document.title = 'Deployments';
  }

  render() {
    const addDeployment = () =>
      this.props.openModal(modalTypes.newDeployment, {
        id: 'new',
        deployment: {}
      });
    const { stories, deployments } = this.props;
    const { showCompleted, preservedState } = this.state;
    const allDeployments = sortBy(deployments, 'id');
    const deploymentWorkPackages = {};
    stories.forEach(workPackage => {
      allDeployments.forEach(deployment => {
        const key = deployment.id;
        if (!deploymentWorkPackages[key]) deploymentWorkPackages[key] = [];
        if (workPackage.deployment && key === workPackage.deployment.id) {
          deploymentWorkPackages[key].push(workPackage);
        }
      });
    });

    return (
      <div className="container-fluid cadencewall deploymentwall planwall">
        <div className="row">
          <div className="top row">
            <div className="col-md-1">
              <GrayPlus handleClick={addDeployment} />
              <button
                type="button"
                className="btn btn-link"
                onClick={addDeployment}
              >
                Add Deployment
              </button>
            </div>
          </div>
          <div className="row">
            {allDeployments.map(deployment => (
              <div
                key={deployment.id}
                className={
                  deployment.status === 'Completed' && !showCompleted
                    ? 'hide'
                    : 'col-md-4 deployments'
                }
              >
                <DeploymentRow
                  deployment={deployment}
                  results={deploymentWorkPackages[deployment.id] || []}
                  add={this.props.addResultToDeployment}
                  remove={this.props.removeResultFromDeployment}
                  showCompleted={showCompleted}
                  preservedState={preservedState}
                  preserveComponentState={this.saveState}
                  fromWall
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

DeploymentsWall.propTypes = {
  deployments: PropTypes.array,
  stories: PropTypes.array,
  openModal: PropTypes.func,
  getAllDeployments: PropTypes.func,
  addResultToDeployment: PropTypes.func,
  removeResultFromDeployment: PropTypes.func
};

const mapStateToProps = state => ({
  deployments: state.deploymentReducer.deployments.filter(d => {
    if (state.trashReducer.showTrash) return true;
    return !d.deleted_at;
  }),
  stories: state.workPackageReducer.stories
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addResultToDeployment,
      removeResultFromDeployment,
      getAllDeployments,
      openModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeploymentsWall);
